/*
 * Copyright (C) 2017 envisia GmbH
 * All Rights Reserved.
 */
import {cva} from 'class-variance-authority';

export interface StreamModel {
  name: string;
  data: any;
}

export interface StatefulModel {
  price: boolean;
  print_failed: boolean;
}

export type PriceDebugCode =
  'General' |
  'Microvias' |
  'MicroviasTooling' |
  'MicroviasType6' |
  'TableNotFound' |
  'SampleCalc' |
  'ExtraTotal' |
  'EndPrice' |
  'Important' |
  'GoldSurface' |
  'GoldSurface2' |
  'CopperFoil' |
  'Lose';

export const messageVariants = cva(
  'whitespace-pre-wrap px-1 py-0.5',
  {
    variants: {
      code: {
        General: 'bg-debug-general-background text-debug-general',
        Microvias: 'bg-debug-microvias-background text-debug-microvias',
        MicroviasTooling: 'bg-debug-microvias-tooling-background text-debug-microvias-tooling',
        MicroviasType6: 'bg-debug-microvias-type6-background text-debug-microvias-type6',
        TableNotFound: 'bg-debug-table-not-found-background text-debug-table-not-found',
        SampleCalc: 'bg-debug-sample-calc-background text-debug-sample-calc',
        ExtraTotal: 'bg-debug-extra-total-background text-debug-extra-total',
        EndPrice: 'bg-debug-end-price-background text-debug-end-price',
        Important: 'bg-debug-important-background text-debug-important',
        GoldSurface: 'bg-debug-gold-surface-background text-debug-gold-surface',
        GoldSurface2: 'bg-debug-gold-surface2-background text-debug-gold-surface2',
        CopperFoil: 'bg-debug-copper-foil-background text-debug-copper-foil',
        Lose: 'bg-debug-lose-background text-debug-lose',
      },
    },
    defaultVariants: {
      code: 'General',
    },
  });

export interface PriceDebugMessage {
  msg: string;
  code: PriceDebugCode;
}
